import { FormBoleto } from "views/components/form/master/boleto/form-boleto";
import { BoletoFormRef } from "../../dialog-boleto";
import { Box, Button, Grid } from "@material-ui/core";
import { useCallback } from "react";
import { useShowAviso } from "services/app/hooks/show-aviso";
import { usePutBoleto } from "data/api/gestao/boleto/put-boleto";
import { LixoIcon, SalvarEditarIcon } from "views/components/icons";
import { useDeleteBoleto } from "data/api/gestao/boleto/delete-boleto";
import { useCadastros } from "services/app/hooks/cadastros";
import { useConfirmSaurus } from "services/app/hooks/confirm-saurus";
import { useThemeQueries } from "views/theme";
import { AccordionHistoricoBoleto } from "./components/accordion-historico";
import { BoletoGetModel } from "model/api/gestao/boleto/boleto-get-model";
import { EnumStatusBoleto } from "model/enums/enum-status-boleto";
import { NovoBoletoModel } from "model/api/gestao/boleto/novo-boleto-model";
import { CancelIcon } from "views/components/icons/cancel-icon";
import { usePutCancelarBoleto } from "data/api/gestao/boleto/put-cancelar-boleto";
import { useStyles } from "./visualizacao-boleto-styles";
interface VisualizacaoBoletoProps {
    formRef: React.RefObject<BoletoFormRef>;
    carregando: boolean;
    id: string;
    boleto: BoletoGetModel;
    getBoletoWrapper: (id: string) => Promise<void>
}

export const VisualizacaoBoleto = ({
    formRef,
    carregando,
    id,
    boleto,
    getBoletoWrapper
}: VisualizacaoBoletoProps) => {

    const { showAviso } = useShowAviso();
    const { showConfirm } = useConfirmSaurus();
    const { fecharDialogBoleto } = useCadastros();
    const { theme } = useThemeQueries();


    const { putBoleto, carregando: carregandoPut } = usePutBoleto()
    const { deleteBoleto, carregando: carregandoDelete } = useDeleteBoleto();
    const { putCancelarBoleto, carregando: carregandoCancel } = usePutCancelarBoleto();
    const loading = carregando || carregandoPut || carregandoDelete || carregandoCancel;
    const permissaoCancelarBoleto = boleto.status.toString() === EnumStatusBoleto.Aceito
    const classes = useStyles()

    const handleSubmit = useCallback(async (model: NovoBoletoModel) => {
        try {
            const res = await putBoleto(model);

            if (res.erro) throw res.erro

            const data = res.resultado?.data;

            if (data?.status.toString() === EnumStatusBoleto.Rejeitada) {
                showAviso('warning', data.historico.list[0].ocorrencia);
                return
            }

            showAviso('success', 'Boleto alterado com sucesso!')
        } catch (e: any) {
            showAviso('error', e.message)
        }
    }, [putBoleto, showAviso])


    const removeBoleto = useCallback(() => {
        const remove = async () => {
            try {
                const res = await deleteBoleto(id)

                if (res.erro) throw res.erro

                showAviso('success', 'Boleto Excluído.');

                fecharDialogBoleto();
            } catch (e: any) {
                showAviso(e.message, 'error')
            }
        }

        showConfirm({
            title: 'Tem certeza que deseja excluir este Boleto?',
            description: 'Esta ação não poderá ser desfeita.',
            primaryButtonColor: theme.palette.error.main,
            primaryButtonText: 'Excluir',
            secondaryButtonText: 'Cancelar',
            secondaryButtonColor: theme.palette.grey[700]
        }).then(() => remove())
    }, [deleteBoleto, fecharDialogBoleto, id, showAviso, showConfirm, theme.palette.error.main, theme.palette.grey])

    const cancelarBoleto = useCallback(async () => {
        const cancelaBoleto = async () => {
            try {
                const res = await putCancelarBoleto(id)

                if (res.erro) throw res.erro

                showAviso('success', 'Boleto cancelado com sucesso!')
                getBoletoWrapper(id)
            } catch (e: any) {
                showAviso(e.message, 'error')
            }
        }

        showConfirm({
            title: 'Tem certeza que deseja solicitar o cancelamento deste Boleto?',
            description: 'Esta ação não poderá ser desfeita.',
            primaryButtonColor: theme.palette.info.dark,
            primaryButtonText: 'Cancelar',
            secondaryButtonText: 'Fechar',
            secondaryButtonColor: theme.palette.grey[700]
        }).then(() => cancelaBoleto())

    }, [getBoletoWrapper, id, putCancelarBoleto, showAviso, showConfirm, theme.palette.grey, theme.palette.info.dark])

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <FormBoleto
                    boleto={boleto}
                    loading={loading}
                    showLoading
                    onSubmit={handleSubmit}
                    ref={formRef}
                />
            </Grid>
            <Grid item xs={12}>
                <AccordionHistoricoBoleto
                    id={id}
                    historico={boleto.historico}
                />
            </Grid>
            <Grid item xs={12} container justifyContent='space-between' alignItems="center">
                <Box gridGap={8} display='flex'>
                    <Button variant="contained" size="small" className={classes.deleteButton} onClick={removeBoleto}>
                        <LixoIcon tipo="BUTTON" class={classes.deleteIcon} />
                        Excluir
                    </Button>
                    {permissaoCancelarBoleto && (
                        <Button variant="contained" className={classes.cancelButton} size="small" onClick={cancelarBoleto}>
                            <CancelIcon tipo="BUTTON" class={classes.cancelIcon} />
                            Cancelar
                        </Button>
                    )}
                </Box>
                <Button variant='contained' color='primary' size='small' onClick={() => formRef.current?.submitForm()}>
                    <SalvarEditarIcon tipo='BUTTON_PRIMARY' />
                    {boleto?.status.toString() === (EnumStatusBoleto.Rejeitada || EnumStatusBoleto.SemRemessa) ? 'Salvar e Reemitir' : 'Alterar'}
                </Button>
            </Grid>
        </Grid>
    )
}